const CustomDropdownPOV = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "gray" : "black",
    color: "white",
    width: "100%",
    Zindex: "10",

    "&:hover": {
      backgroundColor: "gray",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
  }),
};

export default CustomDropdownPOV;
